export enum OrderByClassesFilterKey {
  OrgType = 'orgTypeFilter',
  Org = 'orgFilter',
  Details = 'detailsFilter',
  GroupBy = 'groupByFilter',
  Date = 'dateFilter',
  Period = 'periodFilter',
  OperationAge = 'operationAgeFilter',
  CafeteriaManagerSignatory = 'cafeteriaManagerSignatoryFilter',
  FoodResponsibleSignatory = 'foodResponsibleSignatoryFilter',
  AccountantSignatory = 'accountantSignatoryFilter',
  Building = 'buildingFilter',
}
